module.exports = __webpack_public_path__ + "assets/img/to_help_page.6b814713.svg";